// Simple notes reducer for storing notes by requestId
const initialState = {
  requests: {}
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case 'NOTES/SAVE_NOTES': {
      const { requestId, notes } = action.payload
      return {
        ...state,
        requests: {
          ...state.requests,
          [requestId]: notes
        }
      }
    }
    default:
      return state
  }
}

export default reducer

// Action creator
export const saveNotes = (requestId, notes) => ({
  type: 'NOTES/SAVE_NOTES',
  payload: { requestId, notes }
})

// Selector: get notes by requestId
export const selectNotesByRequestId = (state, requestId) =>
  state.notes?.requests?.[requestId] || []

// Selector: get all notes (flattened)
export const selectAllNotes = (state) => {
  const requests = state.notes?.requests || {}
  return Object.values(requests).flat()
}
